import { ensureCsrfCookie } from '@/shared/lib/httpClient'
import { hasPaymentReturnSignal } from '@/shared/lib/paymentReturnHandler'
import { readPspReturnPending } from '@/shared/lib/pspReturn'

const PAYMENT_RETURN_GRACE_MS = 10_000

let paymentReturnGraceUntil = 0
let bootstrapPromise: Promise<void> | null = null

export function isInPaymentReturnGrace(): boolean {
  return Date.now() < paymentReturnGraceUntil
}

export function beginPaymentReturnGrace(durationMs = PAYMENT_RETURN_GRACE_MS): void {
  paymentReturnGraceUntil = Date.now() + durationMs
}

/** Detect browser return from a PSP checkout (cart, reservation, etc.). */
export function isPaymentReturnSearch(search: Record<string, unknown>): boolean {
  return hasPaymentReturnSignal(search) || readPspReturnPending() !== null
}

/**
 * Refresh CSRF after a cross-site PSP redirect so the first authenticated POST
 * does not race with keep-alive / checkout handlers.
 */
export async function bootstrapPaymentReturn(): Promise<void> {
  if (bootstrapPromise) {
    return bootstrapPromise
  }

  beginPaymentReturnGrace()
  bootstrapPromise = ensureCsrfCookie()
    .catch(() => {
      // Best-effort - downstream requests still retry 419 once via httpClient.
    })
    .finally(() => {
      bootstrapPromise = null
    })

  return bootstrapPromise
}

export function resetPaymentReturnBootstrapForTests(): void {
  paymentReturnGraceUntil = 0
  bootstrapPromise = null
}
